import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import HotelCabinSelect from "@/pages/HotelCabinSelect";
import GuestReservation from "@/pages/GuestReservation";
import TourReservation from "@/pages/TourReservation";
import KitchenLogin from "@/pages/KitchenLogin";
import KitchenDashboard from "@/pages/KitchenDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminQRCodes from "@/pages/AdminQRCodes";
import AdminReservations from "@/pages/AdminReservations";
import AdminTours from "@/pages/AdminTours";
import AdminBirdBrainGuests from "@/pages/AdminBirdBrainGuests";
import AdminCalendars from "@/pages/AdminCalendars";
import HousekeepingLogin from "@/pages/HousekeepingLogin";
import HousekeepingDashboard from "@/pages/HousekeepingDashboard";
import TourStaffLogin from "@/pages/TourStaffLogin";
import TourStaffDashboard from "@/pages/TourStaffDashboard";
import TermsAndConditions from "@/pages/TermsAndConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Contact from "@/pages/Contact";
import RefundPolicy from "@/pages/RefundPolicy";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/hotel/:hotelId" element={<HotelCabinSelect />} />
          <Route path="/reserve/:hotelId/:cabinId" element={<GuestReservation />} />
          <Route path="/tours/:hotelId/:cabinId" element={<TourReservation />} />
          <Route path="/kitchen" element={<KitchenLogin />} />
          <Route path="/kitchen/dashboard" element={<KitchenDashboard />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/qr-codes" element={<AdminQRCodes />} />
          <Route path="/admin/reservations" element={<AdminReservations />} />
          <Route path="/admin/tours" element={<AdminTours />} />
          <Route path="/admin/bird-brain-guests" element={<AdminBirdBrainGuests />} />
          <Route path="/admin/calendars" element={<AdminCalendars />} />
          <Route path="/housekeeping" element={<HousekeepingLogin />} />
          <Route path="/housekeeping/dashboard" element={<HousekeepingDashboard />} />
          <Route path="/tourstaff" element={<TourStaffLogin />} />
          <Route path="/tourstaff/dashboard" element={<TourStaffDashboard />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
